export interface ApiGetQueryCountRequest {
    q: string;
    simple: boolean;
    search_mode: string;
}

export interface ApiGetQueryCountResponse {
    number: number;
}

export const GetQueryCount = Symbol('GetQueryCount');

export interface GetQueryCount {
    getQueryCount(data: ApiGetQueryCountRequest): Promise<ApiGetQueryCountResponse>;
}